import { CommitmentInterface } from '@vendasta/billing';

export interface Commitment {
  initial: number;
  recurring: number;
}

export function commitmentFromAPI(comAPI: CommitmentInterface | undefined): Commitment {
  return {
    initial: comAPI?.initial || 0,
    recurring: comAPI?.recurring || 0,
  };
}
